export const DIGITAL_RUS_REGIONS = [`novyj-urengoj`, `yaroslavl`, `kazan`]

export const PORTATIVNAYA_TECHINIKA_DETAILS = {
	title: `ООО «Портативная техника»`,
	items: [
		{
			key: `Юридический адрес`,
			value: `196105, г. Санкт-Петербург, вн. тер.г. муниципальный округ Московская застава, Московский проспект, дом 158, литера Б, помещение 3Н, офис 116,`
		},
		{
			key: `Адрес для корреспонденции`,
			value: `196105, Санкт-Петербург, а/я №121`
		},
		{
			key: `ИНН`,
			value: `7838330803`
		},
		{
			key: `КПП `,
			value: `781001001`
		},
		{
			key: `ОКПО `,
			value: `77706161`
		},
		{
			key: `ОГРН № `,
			value: `1057811930296`
		},
		{
			key: `ОКАТО`,
			value: `40262562000`
		},
		{
			key: `Телефон/факс`,
			value: `8 (812) 385-14-50`
		},
		{
			key: `Электронная почта`,
			value: `office@nbcom.ru`
		}
	]
}
export const OOO_TEHNICHESKIE_SYSTEMI_DETAILS = {
	title: `Сервисные центры iPort ООО «Технические системы»`,
	items: [
		{
			key: `Юридический адрес`,
			value: `196105, Санкт-Петербург г, Московский пр-кт, дом № 158, литер Б, офис 54`
		},
		{
			key: `Адрес для корреспонденции`,
			value: `196105, Санкт-Петербург, а/я №125`
		},
		{
			key: `ИНН`,
			value: `7811426890`
		},
		{
			key: `КПП `,
			value: `781001001`
		},
		{
			key: `ОКПО `,
			value: `89095074`
		},
		{
			key: `ОГРН № `,
			value: `1097847000184`
		},
		{
			key: `ОКТМО`,
			value: `40373000`
		},
		{
			key: `ОКВЭД`,
			value: `95.11 – Ремонт компьютеров и периферийного компьютерного оборудования`
		},
		{
			key: `Телефон/факс`,
			value: `8 (812) 385-14-50`
		},
		{
			key: `Электронная почта`,
			value: `office@nbcom.ru`
		}
	]
}

export const OOO_ITECH_SERVICE_DETAILS = {
	title: `Общество с ограниченной ответственностью «АйТех Сервис»`,
	items: [
		{
			key: `Юридический адрес`,
			value: `196105, Санкт-Петербург, вн.тер.г.муниципальный округ Московскаязастава, Московский проспект,дом 158, лит. Б, помещение 2Н, офис 82`
		},
		{
			key: `Адрес для корреспонденции`,
			value: `196105, Санкт-Петербург, а/я №125`
		},
		{
			key: `ИНН`,
			value: `7810381935`
		},
		{
			key: `КПП `,
			value: `781001001`
		},
		{
			key: `ОКПО `,
			value: `64489688`
		},
		{
			key: `ОГРН № `,
			value: `1257800012260`
		},
		{
			key: `ОКТМО`,
			value: `40373000000`
		},
		{
			key: `ОКВЭД`,
			value: `95.12`
		},
		{
			key: `Телефон/факс`,
			value: `8 (812) 385-14-50`
		},
		{
			key: `Электронная почта`,
			value: `office@nbcom.ru`
		}
	]
}

export const DIGITAL_RUS_DETAILS = {
	title: `ООО «ДИДЖИТАЛ РУС»
`,
	items: [
		{
			key: `Юридический адрес`,
			value: `196105, Санкт-Петербург, Московский проспект, дом 158, лит. Б, 3 этаж, помещение 3Н, офис 129`
		},
		{
			key: `Адрес для корреспонденции`,
			value: `196105, Санкт-Петербург, Московский проспект, дом 158, лит. Б, 3 этаж, помещение 3Н, офис 129`
		},
		{
			key: `ИНН`,
			value: `7801715684`
		},
		{
			key: `КПП `,
			value: `780101001`
		},
		{
			key: `ОГРН № `,
			value: `1227800108898`
		},
		{
			key: `Телефон/факс`,
			value: `8 (812) 385-14-50`
		},
		{
			key: `Электронная почта`,
			value: `office@nbcom.ru`
		}
	]
}
